import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const userTask = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name for this task'),

    status: z
      .enum(['Active', 'Paused', 'Complete', 'Canceled'])
      .nullable()
      .optional()
      .describe('Current state of this task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe(
        'In-progress working data for this task, merged into process instance data on completion',
      ),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was finished'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    roleId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .presentAs('select-role')
      .describe('Foreign key to Role'),

    userId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .presentAs('select-user')
      .describe('Foreign key to User'),

    token: belongsTo('Token'),

    role: references('Role', 'roleId'),

    user: references('User', 'userId'),

    tokens: hasMany('Token', 'currentUserTaskId'),

    userTaskHistories: hasMany('UserTaskHistory', 'userTaskId'),
  })
  .describe('A task that requires a user to take action')
  .as('UserTask');

export { userTask as userTaskSchema };
